import { useMemo } from 'react'
import { usePotentials } from '../basket/potentials'
import { useTranslation } from '../localization/useTranslation'
import { useCheckoutStore } from '../store/checkout'
import { useSetPageTitle } from '../store/pageTitle'
import { Glyph } from '../ui/icons'

/**
 * Optional, brand-gated "Share your story" step: one free-text box per basket item. Stories are
 * kept in the checkout store keyed by the potential's `_id`, so a story lives next to its product
 * and is dropped when that product leaves the basket. The share-consent tick is disabled until the
 * customer writes something, and FlowLayout requires it to continue once anything is written
 * (mirrors v1's CommentsForm). The collected stories feed the final TradeInCreate as comments.
 */
export function YourStoryPage() {
  const { potentials } = usePotentials()
  const stories = useCheckoutStore((s) => s.stories)
  const setStory = useCheckoutStore((s) => s.setStory)
  const accept = useCheckoutStore((s) => s.storyConsent)
  const setAccept = useCheckoutStore((s) => s.setStoryConsent)
  const { t } = useTranslation()

  const anyWritten = useMemo(
    () => Object.values(stories).some((c) => c.trim().length > 0),
    [stories],
  )
  useSetPageTitle(t('story.title'), t('story.subtitle'))

  return (
    <div className="step">
      <div className="story-list">
        {potentials.map((p) => {
          const image = p.imageUrls?.[0]
          return (
            <div className="story-row" key={p._id}>
              <div className="story-item">
                <span className="thumb" style={{ width: 48, height: 48 }}>
                  {image ? <img src={image} alt="" /> : <Glyph name="shirt" />}
                </span>
                <span className="meta">
                  <div className="nm">{p.name}</div>
                  {p.color && <div className="clr">{p.color}</div>}
                </span>
              </div>
              <div className="story-field">
                <textarea
                  maxLength={500}
                  rows={3}
                  placeholder={t('story.placeholder')}
                  value={stories[p._id] ?? ''}
                  onChange={(e) => setStory(p._id, e.target.value)}
                />
              </div>
            </div>
          )
        })}
      </div>

      <div className={`consent story-consent ${anyWritten ? '' : 'is-disabled'}`}>
        <input
          type="checkbox"
          checked={accept}
          disabled={!anyWritten}
          onChange={(e) => setAccept(e.target.checked)}
        />
        <div>
          <p>{t('story.consent')}</p>
        </div>
      </div>
    </div>
  )
}
